import Icon from './Icon';

interface AppBarProps {
  title?: string;
  trailings?: React.ReactNode;
  className?: string;
  onBack?: () => void;
  leadingIcon?: string;
}

const AppBar: React.FC<AppBarProps> = ({
  title,
  trailings,
  className,
  onBack = () => Transition.back(),
  leadingIcon = "icon/ic_arrow_left.svg"
}) => {
  return (
    <div className={`appbar ${className ?? ''} bg-base-bg-default text-base-txt-primary`}>
      <div className="appbar-exit" onClick={onBack}>
        <Icon name={leadingIcon} />
      </div>
      <div className="appbar-content">
        <div className="appbar-title pt-0">{title || ''}</div>
      </div>
      {!!trailings && <div className="absolute right-0 top-0">{trailings}</div>}
    </div>
  );
};

export default AppBar;
